import { Injectable }    from '@angular/core';
import 'rxjs/add/operator/toPromise';
export class Ppage{
  href: any;
  number: any;
  current: any;
}
@Injectable()
export class PaginationService {

  getPaginationPages(curentPage:any, lastPage:any, maxBut:any) {

      var pages = [{number: curentPage, current: true}];
      var leftShift = lastPage - curentPage >= 2 ? 0 : (Math.floor(maxBut/2) -(lastPage - curentPage))-1;
      var but = maxBut-1;
      var counter = curentPage;
      var p: Ppage;
      if (counter != 1) {
        while(counter != 1 && Math.floor(but/2)+leftShift!=pages.length){        
          counter--;
          p={href: "", number: counter, current: false}
          pages.unshift(p);
        }
      }

      if (curentPage == 1) {
        p={href: curentPage, number: "<", current: false}
        pages.unshift(p);      
      }else{
        p={href: curentPage-1, number: "<", current: false}
        pages.unshift(p);      
      }
    
      counter = curentPage
      if (counter != lastPage) {
        while(counter != lastPage && but!=pages.length){        
          counter++;
          p={href: "", number: counter, current: false}
          pages.push(p);
        }
      }
      if (curentPage == lastPage) {
        p={href: curentPage, number: ">", current: false}
        pages.push(p)
      }else{
        p={href: curentPage+1, number: ">", current: false}
        pages.push(p)      
      }

      return pages;
    
  }
  getSortTipe(sort:string){
    var sortCat:any;
    switch (sort) {
      case "title_desc":
      case "title:desc":
        sortCat = "title:desc"
        break;
      
      case "price_asc":
      case "price:asc":
        sortCat = "price:asc"
        break;
      
      case "price_desc":
      case "price:desc":
        sortCat = "price:asc"
        break;
      
      default:
        sortCat = "title:asc"
        break;
    }
    return sortCat;
  }
  getSortTipeUrl(sort:string){
    var sortCat:any;
    switch (sort) {
      case "title:desc":
        sortCat = "title_desc"
        break;
      
      case "price:asc":
        sortCat = "price_asc"
        break;
      
      case "price:desc":
        sortCat = "price_desc"
        break;
      
      default:
        sortCat = "title_asc"
        break;
    }
    return sortCat;
  }
}



// WEBPACK FOOTER //
// ./src/app/pagination2/pagination.service.ts